export function stringId() {
    const sectionLength = 10;
    const sections = 3;
    let result = '';
    const characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < sections; i++) {
        let counter = 0;
        while (counter < sectionLength) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
            counter += 1;
        }
        if (i !== sections -1) {
            result += '-'
        }
    }

    return result;
}

export function randomId() {
    const sectionLength = 40;
    let result = '';
    const characters = 'abcdefghijklmnopqrstuvwxyz';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < sectionLength) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
    }

    return result;
}
